import type { CollectionModelField } from './collection.field';

/**
 * Breadcrumb of ancestor subform instance titles for `field`, root-to-immediate-parent.
 *
 * Each entry is either the instance's title alone (when it matches the schema title) or
 * `"<instanceTitle> (<schemaTitle>)"` when the user has set a custom title that differs
 * from the schema name — that disambiguates customized subform rows from the schema label.
 *
 * Returns an empty array for root-level fields.
 */
export function describeFieldPath(field: CollectionModelField): string[] {
	const path: string[] = [];
	let parent = field.parent;
	while (parent != null && parent.parent != null) {
		const fieldTitle = parent.title;
		const schemaTitle = parent.formTitle;
		if (fieldTitle !== schemaTitle) {
			path.push(`${fieldTitle} (${schemaTitle})`);
		} else {
			path.push(schemaTitle ?? '');
		}
		parent = parent.parent.parent;
	}
	return path.reverse();
}

/** Field's own display name (`schema.displayName`) paired with its `describeFieldPath`. */
export function describeField(field: CollectionModelField): { name: string; path: string[] } {
	return { name: field.schema.displayName, path: describeFieldPath(field) };
}
